import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Box, Button, Container, Typography } from '@mui/material';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = (): void => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
          <Alert severity="error" sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Algo salió mal
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {this.state.error?.message ?? 'Error desconocido'}
            </Typography>
          </Alert>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={this.handleReset}>
              Recargar página
            </Button>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}
